/* This file is autogenerated, see readme.md for instructions */
import GraphStatsSvgIcon from '@bloomreach/banana-theme/icons/graph-stats.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const GraphStatsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <GraphStatsSvgIcon />
    </Icon>
  );
});

GraphStatsIcon.displayName = 'GraphStatsIcon';

export default GraphStatsIcon;
